/** Columns for child accounts table in AccountChildDrawer. Order: Account Name, Domain, Location, LinkedIn, Industry, Employees, Entity Type */
export const childAccountTableColumns = [
  {
    column_id: 'column-name',
    title: 'Account Name',
    field: 'name',
    disabled: true,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-entity-type',
    title: 'Entity Type',
    field: 'type',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-location',
    title: 'Location',
    field: 'country',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-domain',
    title: 'Domain',
    field: 'domain',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-linkedin',
    title: 'LinkedIn',
    field: 'linkedin_url',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  // {
  //   column_id: 'column-industry',
  //   title: 'Industry',
  //   field: 'industry',
  //   disabled: false,
  //   checked: true,
  //   preferred: true,
  //   category: 'Account',
  // },
  // {
  //   column_id: 'column-employee-count',
  //   title: 'Employees',
  //   field: 'associated_employee_count',
  //   disabled: false,
  //   checked: true,
  //   preferred: true,
  //   category: 'Account',
  // },
];

export const similarCompaniesDrawerColumns = [
  {
    column_id: 'similar-column-name',
    title: 'Account Name',
    field: 'name',
    disabled: true,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'similar-column-domain',
    title: 'Domain',
    field: 'domain',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'similar-column-industry',
    title: 'Industry',
    field: 'industry',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'similar-column-revenue',
    title: 'Revenue',
    field: 'revenue',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'similar-column-employee-count',
    title: 'Employee Count',
    field: 'employee_count',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
];

export const accountsTableColumns = [
  {
    column_id: 'column-name',
    title: 'Account Name',
    field: 'name',
    disabled: true,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-industry',
    title: 'Primary Industry',
    field: 'industry',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-sub-industry',
    title: 'Sub Industry',
    field: 'sub_industry',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-other-industry',
    title: 'Other Industries',
    field: 'industries',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-revenue',
    title: 'Revenue',
    field: 'revenue',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-employeeCount',
    title: 'Employee Range',
    field: 'employee_count',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-people',
    title: 'Employee Count',
    field: 'associated_employee_count',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-country-distribution',
    title: 'Global Presence',
    field: 'employee_distribution',
    disabled: false,
    checked: true,
    category: 'Account',
  },
  {
    column_id: 'column-latest-funding-date',
    title: 'Latest Funding Date',
    field: 'latest_funding_date',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-total-funding-amount',
    title: 'Total funding amount',
    field: 'total_funding',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-latest-funding-amount',
    title: 'Latest Funding Amount',
    field: 'latest_funding',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-latest-funding-stage',
    title: 'Latest Funding Stage',
    field: 'latest_funding_stage',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-foundedYear',
    title: 'Founded Year',
    field: 'founded_year',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-account-city',
    title: 'Account City',
    field: 'city',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-account-state',
    title: 'Account State',
    field: 'state',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-account-country',
    title: 'Account Country',
    field: 'country',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-postalCode',
    title: 'Postal Code',
    field: 'postal_code',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-technologies',
    title: 'Technologies',
    field: 'technologies',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-naics-code',
    title: 'NAICS Code',
    field: 'naics_codes',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-sic-code',
    title: 'SIC Code',
    field: 'sic_codes',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-company-keyword',
    title: 'Company Keyword',
    field: 'keywords',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-business-classification',
    title: 'B2B / B2C',
    field: 'business_classification',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-profit-non-profit',
    title: 'Profit / Non Profit',
    field: 'profit_non_profit',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-product-service',
    title: 'Product / Service',
    field: 'product_service',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-govt-non-govt',
    title: 'Govt / Non Govt',
    field: 'govt_non_govt',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
];

export const contactTableColumns = [
  {
    column_id: 'column-contact-name',
    title: 'Contact Name',
    field: 'name',
    disabled: true,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-account-name',
    title: 'Account Name',
    field: 'account_name',
    disabled: true,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-jobTitle',
    title: 'Job Title',
    field: 'job_title',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-designation',
    title: 'Seniority',
    field: 'cataloger_designations',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-department',
    title: 'Department',
    field: 'cataloger_departments',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-jobFunctions',
    title: 'Sub Department',
    field: 'cataloger_divisions',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-contact-city',
    title: 'Contact City',
    field: 'city',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-contact-state',
    title: 'Contact State',
    field: 'state',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-contact-country',
    title: 'Contact Country',
    field: 'country',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Contact',
  },
  {
    column_id: 'column-industry',
    title: 'Primary Industry',
    field: 'industry',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-sub-industry',
    title: 'Sub Industry',
    field: 'sub_industry',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-other-industry',
    title: 'Other Industries',
    field: 'industries',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-revenue',
    title: 'Revenue',
    field: 'revenue',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-employeeCount',
    title: 'Employee Range',
    field: 'employee_count',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-people',
    title: 'Employee Count',
    field: 'associated_employee_count',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-latest-funding-date',
    title: 'Latest Funding Date',
    field: 'latest_funding_date',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-total-funding-amount',
    title: 'Total funding amount',
    field: 'total_funding',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-latest-funding-amount',
    title: 'Latest Funding Amount',
    field: 'latest_funding',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-latest-funding-stage',
    title: 'Latest Funding Stage',
    field: 'latest_funding_stage',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Funding',
  },
  {
    column_id: 'column-foundedYear',
    title: 'Founded Year',
    field: 'founded_year',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-account-city',
    title: 'Account City',
    field: 'city',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-account-state',
    title: 'Account State',
    field: 'state',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-account-country',
    title: 'Account Country',
    field: 'country',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-postalCode',
    title: 'Postal Code',
    field: 'postal_code',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-technologies',
    title: 'Technologies',
    field: 'technologies',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-naics-code',
    title: 'NAICS Code',
    field: 'naics_codes',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-sic-code',
    title: 'SIC Code',
    field: 'sic_codes',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-company-keyword',
    title: 'Company Keyword',
    field: 'keywords',
    disabled: false,
    checked: true,
    preferred: true,
    category: 'Account',
  },
  {
    column_id: 'column-business-classification',
    title: 'B2B / B2C',
    field: 'business_classification',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-profit-non-profit',
    title: 'Profit / Non Profit',
    field: 'profit_non_profit',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-product-service',
    title: 'Product / Service',
    field: 'product_service',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
  {
    column_id: 'column-govt-non-govt',
    title: 'Govt / Non Govt',
    field: 'govt_non_govt',
    disabled: false,
    checked: false,
    preferred: false,
    category: 'Account',
  },
];
